import React, { Component } from "react";
import { strings } from "../../logik/tuning/frequencies";
import ModellAuswahl from "./ModellSelection";
import SaitenAuswahl from "./SaitenAuswahl";
import { fb } from "./../../App";

type Props = {
    cookies: boolean;
    messaging: any;
    setMassaging: any;
    db: any;
};

type State = {
    activeInstrument: null | {
        label: string;
        reverse: boolean;
        strings: {
            note: string;
            freq: number;
        }[];
    };
};

export default class StimmGeraet extends Component<Props, State> {
    state = {
        activeInstrument: null,
    };
    constructor(props: Props) {
        super(props);

        this.onSelect = this.onSelect.bind(this);
    }

    componentDidMount() {
        try {
            if (localStorage.getItem("Instrument")) {
                console.log("ja moinn");
                var stringszw = strings.find(
                    (e: any) => e.label === localStorage.getItem("Instrument")
                );
                if (stringszw) {
                    this.setState({ activeInstrument: stringszw });
                }
            }
        } catch (err) {
            this.setState({ activeInstrument: null });
        }
    }

    render() {
        return (
            <>
                {this.state.activeInstrument ? (
                    <SaitenAuswahl
                        messaging={this.props.messaging}
                        setMessageing={this.props.setMassaging}
                        activeInstrument={this.state.activeInstrument}
                        onSelect={this.onSelect}
                        db={this.props.db}
                    />
                ) : (
                    <ModellAuswahl
                        onSelect={this.onSelect}
                        instrument={this.state.activeInstrument}
                        cookies={this.props.cookies}
                    />
                )}
            </>
        );
    }

    onSelect(e: any, label: string, code: string) {
        this.setState({
            activeInstrument: e,
        });
        if (fb && label) {
            fb.analytics().logEvent("select_content", {
                content_type: label,
            });
        }
        localStorage.setItem("Instrument", label);

        code && localStorage.setItem("InstrumentKey", code);
    }
}
